
(function () {
	'use strict';

	angular
		.module('in-out-rm')
		.controller('postOrderController', postOrderController);

	postOrderController.$inject = ['$scope','$http','postOrderData','$sce','$rootScope','fileDownload','$filter','sidetopHttp'];

	function postOrderController($scope,$http,postOrderData,$sce,$rootScope,fileDownload,$filter,sidetopHttp) {
		$scope.data = {};
		$scope.loading = false;
		$scope.failed = true;
		$scope.recheckDisabled = true;
		$scope.info={};
		$scope.info.countdown = 60;
		$scope.recheckText = $filter('asPortalLang')('Recheck_Status','Recheck status');
		$scope.email=$rootScope.app_data.data.replyto_email;
		$scope.userEmail={ 'userEmail': '' }
		var timer = setInterval(function () {
		    if ($scope.info.countdown > 0) {
		        $scope.info.countdown--;
		        $scope.$apply();
		    } else {
		        $scope.recheckDisabled = false;
		        clearInterval(timer);
		        $scope.$apply();
		    }
		    as_upgrade(100);
		}, 1000);
		$scope.isEmailEmpty=function(){
			if($rootScope.app_data.data.replyto_email && $rootScope.app_data.data.replyto_email.trim()!=''){
				return true;
			} 
			return false;
		}
		$scope.isNotEmailEmpty=function(){
			if(!$rootScope.app_data.data.replyto_email || $rootScope.app_data.data.replyto_email.trim()==''){
				return true;
			} 
			return false;
		}
		$scope.contactEmail= $filter("asLingo")('109');

		$scope.urlToshare=COMM_APPBASE+"donation/"+postOrderData.data.data.project_id;
		$scope.email=$rootScope.app_data.data.replyto_email;
		$scope.isEmailEmpty=function(){
			if($rootScope.app_data.data.replyto_email && $rootScope.app_data.data.replyto_email.trim()!=''){
				return true;
			} 
			return false;
		}
		$scope.isNotEmailEmpty=function(){
			if(!$rootScope.app_data.data.replyto_email || $rootScope.app_data.data.replyto_email.trim()==''){
				return true;
			} 
			return false;
		}
		$scope.contactEmail= $filter("asLingo")('109');

		$scope.downloadEventTicket = downloadEventTicket;
		//Activate Function
		activate();
		
		function activate() {
			$scope.data.view = $filter('asPortalLang')('Trying_Fetch_Res','Trying to fetch payment response.');
			if(postOrderData.data.success == 1){
				$scope.data = postOrderData.data.data;
				$scope.paymentFor={'paymentFor':$scope.data.payment_for}
				$scope.data.view = $sce.trustAsHtml($scope.data.view);
				var elapsedTime = 0; 
		        var interval = setInterval(function() {
		            elapsedTime += 5000;
		            if (angular.isDefined($scope.data) && $scope.data.order.transaction_status == 0 && $scope.data.transactionSuccess == 0) {
		                $scope.recheck();
		            } else {
		                clearInterval(interval);
		            }
		            if (elapsedTime >= 120000) {
		                clearInterval(interval);
		            }
		        }, 5000);
				if ($scope.data.transactionSuccess!=undefined && $scope.data.transactionSuccess==1) {
					$scope.failed = false;
					if($scope.data && $scope.data.user_det && $scope.data.user_det.email)
					{
						$scope.userEmail={
							'userEmail':$scope.data.user_det.email
						};
					}
				}
				else $scope.failed = true;
			}else {
				$scope.failed = true;
			}
		}
		$scope.getLifeMemberData = function() {
			return  {
			ProfileLinkStart: "<a ui-sref=\"inapp.profile_2({source:'lmPayment'})\">",
			ProfileLinkEnd : "</a>"
			};
			}
		function downloadEventTicket(){
            if(!$scope.data || !$scope.data.ticket_url)
                return false;
            fileDownload.do($scope.data.ticket_url,'pdf');
        }

        $scope.getDonationData = function(data) {
        	if(data.terminology){
        	var donation_txt = $filter('asDonation')(data.terminology,'donation');
        	if(data&&data.projectURL&&data.projectName){
	        	var data = {
	        		'ProjectName': "<a class=\"link-detail mdl-color-text--grey-900 mdl-typography--font-regular\" href=\""+data.projectURL+"\">" + data.projectName + "</a>",
	        		'donationTerm': $filter("asPortalLang")(donation_txt,donation_txt)
	        	}
	        	return data;
	        }
	        }
	        return {'ProjectName':'', 'donationTerm':''};
	        	
        }
        $scope.recheck = function(){
        	$scope.recheckText = $filter('asPortalLang')('Checking','Checking...');
        	sidetopHttp.postDataCall('./orders/gateway/recheckStatus',{order_id:postOrderData.data.data.order.id}, function(res){
				var map = [];
				var message = '';
				if(res.error && angular.isObject(res.error) && !res.data){
					res.data = res.error;
					delete res['error'];
				}
				if(res.data){
					$scope.data.transactionSuccess = res.data == 10 ? 1 : 0;
					$scope.data.order.transaction_status = res.data;
					$scope.failed = res.data==10? false: true;
				}
				if ($scope.data.transactionSuccess == 0 && $scope.data.order.transaction_status == 0) {
		            $scope.recheckText = $filter('asPortalLang')('Recheck_Status','Recheck status');
		            $scope.recheckDisabled = true;
		            $scope.info.countdown = 30;
		        }
				as_upgrade(100);
			});
        }
	}


})();
